import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Logo } from "../components/store/Header";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      toast.success("Bem-vindo(a) de volta!");
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--site-bg)] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="Dra.Cell Assistência Técnica" className="h-16 w-auto mb-4" />
          <h1 className="font-display font-bold text-2xl tracking-tight">Área do Lojista</h1>
          <p className="text-sm text-[#6B645C] mt-1">Gerencie seu catálogo de qualquer lugar</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-3xl border border-[#E8E2D9] p-8 space-y-4" data-testid="admin-login-form">
          {error && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-4 py-2.5" data-testid="login-error-message">
              {error}
            </p>
          )}
          <div>
            <label htmlFor="email" className="block font-mono text-xs uppercase tracking-wider text-[#5A534C] mb-2">
              E-mail
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="w-full bg-[var(--site-bg)] border border-[#E8E2D9] rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[var(--brand)] transition-colors"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label htmlFor="password" className="block font-mono text-xs uppercase tracking-wider text-[#5A534C] mb-2">
              Senha
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="w-full bg-[var(--site-bg)] border border-[#E8E2D9] rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[var(--brand)] transition-colors"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-[#1A1816] text-white py-3.5 rounded-full font-display text-sm font-semibold hover:bg-[var(--brand)] transition-colors disabled:opacity-60"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
        <p className="text-center mt-6">
          <Link to="/" data-testid="back-to-store-link" className="text-xs text-[#6B645C] hover:text-[#1A1816] transition-colors">
            ← Voltar para a loja
          </Link>
        </p>
      </div>
    </div>
  );
}
